/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Table_Rooms_DescInputs */



/**
* | output |
* | --- |
* | "room names for table ranges in multi-room venues, the first table number and whether each room restarts at 1, at the foot of the Venue section" |
*
* @param {Og_Cfg_Table_Rooms_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_table_rooms_desc = /** @type {((inputs?: Og_Cfg_Table_Rooms_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Table_Rooms_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("noms de salles pour les plages de tables dans les lieux multi-salles, numéro de la première table et renumérotation à 1 dans chaque salle, en bas de la section Lieu")
	if (locale === "es") return /** @type {LocalizedString} */ ("nombres de sala para rangos de mesas en recintos con varias salas, número de la primera mesa y si cada sala vuelve a empezar en 1, al pie de la sección **Sede**")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nomes de salas para intervalos de mesas em locais com múltiplas salas, número da primeira mesa e se cada sala recomeça em 1, no fim da seção Local")
	if (locale === "it") return /** @type {LocalizedString} */ ("nomi delle sale per intervalli di tavoli in sedi con più stanze, numero del primo tavolo e se ogni sala riparte da 1, in fondo alla sezione **Sede**")
	return /** @type {LocalizedString} */ ("room names for table ranges in multi-room venues, the first table number and whether each room restarts at 1, at the foot of the Venue section")
});